export function addDays(date: Date, days: number) {
    const newDate = new Date(date)
    newDate.setDate(date.getDate() + days)
    return newDate
}

export function toLocaleDateTimeString(date: Date) {
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`
}

export function timestampToDate(timestamp: number) {
    if (!timestamp) {
        return "Unknown"
    }

    const date = new Date(timestamp * 1000)
    const currentDate = new Date()

    const diffMs = currentDate.getTime() - date.getTime()
    const diffSeconds = Math.floor(diffMs / 1000)
    const diffMinutes = Math.floor(diffSeconds / 60)
    const diffHours = Math.floor(diffMinutes / 60)
    const diffDays = Math.floor(diffHours / 24)
    const diffWeeks = Math.floor(diffDays / 7)
    const diffMonths = Math.floor(diffDays / 30)
    const diffYears = Math.floor(diffDays / 365)

    if (diffSeconds < 60) {
        return diffSeconds === 1 ? "1 second ago" : `${diffSeconds} seconds ago`
    } else if (diffMinutes < 60) {
        return diffMinutes === 1 ? "1 minute ago" : `${diffMinutes} minutes ago`
    } else if (diffHours < 24) {
        return diffHours === 1 ? "1 hour ago" : `${diffHours} hours ago`
    } else if (diffDays <= 7) {
        return diffDays === 1 ? "1 day ago" : `${diffDays} days ago`
    } else if (diffWeeks <= 4) {
        return diffWeeks === 1 ? "1 week ago" : `${diffWeeks} weeks ago`
    } else if (diffMonths < 12) {
        return diffMonths === 1 ? "1 month ago" : `${diffMonths} months ago`
    } else {
        return diffYears === 1 ? "1 year ago" : `${diffYears} years ago`
    }
}